// src/hooks/useSettings.js
import { useState, useEffect } from 'react';

export const useSettings = () => {
  const [settings, setSettings] = useState({
    logo: '',
    store_name: 'ShopDemo',
    navbar_color: '#ffffff',
    primary_color: '#667eea',
    secondary_color: '#764ba2',
    background_color: '#ffffff',
    hero_title: 'Welcome to ShopDemo',
    hero_subtitle: 'Discover amazing products at unbeatable prices',
    footer_text: '© 2024 ShopDemo. All rights reserved.',
    store_email: 'info@shopdemo.com',
    store_phone: '+1 (555) 123-4567',
    store_address: '123 Demo Street, City'
  });
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(prev => ({ ...prev, ...data.settings }));
        // Apply colors to DOM
        if (data.settings.navbar_color) {
          const navbar = document.querySelector('.navbar');
          if (navbar) navbar.style.backgroundColor = data.settings.navbar_color;
        }
        if (data.settings.background_color) {
          document.body.style.backgroundColor = data.settings.background_color;
        }
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateSettings = async (newSettings) => {
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/admin/update-settings.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(newSettings)
      });
      const data = await response.json();
      if (data.success) {
        setSettings(prev => ({ ...prev, ...newSettings }));
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error updating settings:', error);
      return false;
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return { settings, loading, updateSettings, fetchSettings };
};